var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99512 0.5C10.2154 0.500036 10.3763 0.601609 10.4424 0.733398L11.9424 3.7334L13.2832 6.41406L13.3193 6.48633L13.376 6.54395L13.4062 6.57324L13.4639 6.63086L13.5361 6.66699L16.2168 8.00684L19.207 9.50195L19.2061 9.50684C19.3741 9.59084 19.4805 9.76666 19.4805 9.9502C19.4804 10.1337 19.374 10.3086 19.2061 10.3926L13.5264 13.2324L13.4541 13.2695L13.3965 13.3262L13.3086 13.4141L10.4326 19.166C10.3486 19.334 10.1737 19.4403 9.99023 19.4404C9.80669 19.4404 9.63088 19.334 9.54688 19.166L6.6709 13.4141L6.61328 13.3564L6.58398 13.3262L6.52637 13.2695L6.45312 13.2324L0.773438 10.3926C0.605617 10.3086 0.500075 10.1336 0.5 9.9502C0.5 9.76666 0.60543 9.59084 0.773438 9.50684L6.45312 6.66699L6.52637 6.63086L6.6709 6.48633L6.70703 6.41406L8.04688 3.7334L9.54688 0.733398C9.61287 0.601441 9.77458 0.5 9.99512 0.5Z",
    fill: "#FAE799",
    stroke: "#C5A86E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ebf0f28eb177cee57266732be9ab1180.svg";
export { ForwardRef as ReactComponent };